'use strict';

var MITS = require('./mits');

MITS.AjaxAPI = require('./AjaxAPI');
MITS.DrillAcrossHelper = require('./DrillAcrossHelper');
MITS.Events = require('./Events');
MITS.Storage = require('./Storage');
MITS.UI = require('./UI');
MITS.WebRemoting = require('./WebRemoting');
MITS.Widgets = require('./Widgets');

//This are delegates because user code expects them to be on MITS, but we're trying to eliminate dependencies on the
// root MITS object in the children
MITS.getCurrentModal = function() {
    return MITS.Widgets.ModalManager.getCurrentModal();
};

MITS.getCurrentMessageModal = function() {
    return MITS.Widgets.ModalManager.getCurrentMessageModal();
};

MITS.getCurrentModalWizard = function(){
    return MITS.Widgets.ModalManager.getCurrentModalWizard();
};
MITS.getPreferenceManager = function() {
    return MITS.Storage.getPreferenceManager();
};

module.exports = MITS;// This is expected to end up in a global var named 'MITS'


//////////////////
// WEBPACK FOOTER
// ./mits/index.js
// module id = 22
// module chunks = 0